<script lang="ts">
  // The apibim wordmark, ported from the company site (src/shared/icons/logos/LogoBlack.tsx).
  // Filled with currentColor rather than a baked-in hex so one component serves every context —
  // the site ships separate black and white variants for exactly this reason.

  let { height = 24 }: { height?: number } = $props();

  const ASPECT = 167.3 / 44;
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 167.3 44"
  {height}
  width={height * ASPECT}
  fill="currentColor"
  role="img"
  aria-label="apibim"
>
  <path
    d="M14.7,0v12.2H0v31.8h49.8V0H14.7ZM29.1,41.4h-12v-12h12v12ZM47.3,41.4h-15.8V12.3h-14.4V2.5h30.2v38.9Z"
  />
  <path d="M79.1,26.6h-5.4l-.8,2.8h-4.9l5.9-17.1h5.3l5.8,17h-5l-.8-2.7ZM78.2,22.9l-1.8-6.1-1.7,6.1h3.4Z" />
  <path
    d="M85.5,12.2h8c1.8,0,3.1.4,3.9,1.4.9.9,1.3,2.2,1.3,3.9s-.4,3.1-1.4,4c-1,1-2.4,1.5-4.3,1.5h-2.6v6.3h-4.8V12.2ZM90.4,19.5h1.1c1,0,1.6-.2,1.9-.5.4-.4.5-.8.5-1.3s-.2-1-.5-1.4c-.4-.4-1-.5-1.8-.5h-1.4v3.8h.2Z"
  />
  <path d="M100.6,12.2h4.8v17h-4.8V12.2Z" />
  <path
    d="M108.1,12.2h9c1.5,0,2.6.4,3.4,1.2.8.8,1.2,1.8,1.2,3s-.3,1.8-.9,2.6c-.4.4-1,.9-1.7,1.1,1.1.3,1.9.8,2.5,1.5.5.7.8,1.6.8,2.7s-.2,1.7-.5,2.4c-.4.7-.9,1.2-1.5,1.7-.4.3-1.1.4-1.8.5-1.1.2-1.8.3-2.1.3h-8.3V12.2h0ZM112.9,19h2.1c.8,0,1.2-.2,1.6-.4.3-.3.4-.7.4-1.2s-.2-.9-.4-1.1-.8-.4-1.5-.4h-2.1v3.2h0ZM112.9,25.7h2.5c.8,0,1.4-.2,1.8-.5s.5-.8.5-1.3-.2-.9-.5-1.2c-.4-.3-1-.4-1.8-.4h-2.5v3.5Z"
  />
  <path d="M124.2,12.2h4.8v17h-4.8V12.2Z" />
  <path d="M131.5,12.2h6.3l2.5,10.4,2.5-10.4h6.3v17h-4v-12.9l-3.1,13h-3.5l-3-13v13h-4V12.2Z" />
</svg>
